import React from "react";
import { Datagrid, FunctionField, TextField } from "react-admin";
import Actions from "./Actions";
import { formatDate } from "../../../../../../Helper/MomentHelper";

export const OpenRequestsDataGrid = props => {
  return (
    <Datagrid optimized {...props} hasBulkActions={false}>
      <Actions label="Actions" {...props} />
      <TextField source="request.refNo" label="Ref No" />
      <TextField source="request.customerPo" label="Customer Po" />
      <TextField source="request.customerCode" label="Customer" />
      <TextField source="request.requirementCategoryText" label={"Requirement Category"} />
      <TextField source="request.pn" label={"Part No"} />
      <TextField source="request.isPool" label={"Pool Scope"} />
      <TextField source="request.airportCode" label={"Destination"} />
      <TextField source="request.acRegistration" label={"AC"} />
      <FunctionField
        label="Requested Date"
        render={(record: any) => {
          return formatDate(record.request.createdDate);
        }}
      />
      <FunctionField
        label="Requested Delivery Date"
        render={(record: any) => {
          return record.request.requestedDeliveryDate === null
            ? "Not Arrived Yet"
            : formatDate(record.request.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
              ? "Exclude"
              : formatDate(record.request.requestedDeliveryDate, false);
        }}
      />
    </Datagrid>
  );
};

export default OpenRequestsDataGrid;
